import {
  mapToArray,
  buildParent,
  mapEventsToColumnSelector,
} from './util';
import { columnSelector } from './columnSelector';
import { deepFind } from '../../../util/util';

/**
 * Iterate over child nodes and append to the container
 * @param  {object} options.selectedRows    [currently selected rows]
 * @param  {object || array} options.map    [map to start with]
 * @param  {function} options.sortMethod    [sort function to use]
 * @param  {function} options.events        [(key) => {} function to use for events]
 * @param  {node} options.container         [container to append items to]
 * @param  {String} options.parentSlug      [slug of the parent]
 * @param  {Number} options.depth           [current depth of recursion]
 * @param  {Object} options.wrapups         [wrapups]
 * @return {node}                           [container with appened items]
 */
export default function iterateOverChildNodes({
  selectedRows,
  map,
  sortMethod,
  events,
  container,
  parentSlug = '',
  depth = 0,
  wrapups = {},
  isMedicare = false,
}) {
  // if map is an array no need to convert to one... we can also assume already sorted
  return (Array.isArray(map) ?
      map :
      Object.keys(map)
        .map(mapToArray(map))
        .sort(sortMethod)
    )
    .reduce(
      (acc, { key, label, children }) => {
        // Set the parent keys to the split slug
        const parentKeys = parentSlug.length ? parentSlug.split('--') : [];

        if (children) {
          const wrapper = document.createElement('div');
          wrapper.setAttribute('class', 'accordion-wrapper');
          const childWrapper = document.createElement('dl');
          childWrapper.setAttribute('class', 'accordionShow');

          // If the currently selected rows have any child keys that
          // belong to this parent, we need have that parent 'active'
          // and have its children visible
          const parentIsActive =
            !isMedicare ||
            (!isMedicare && depth === 0) ||
            deepFind([...parentKeys, key], selectedRows) !== false ||
              deepFind([...parentKeys, 'all'], selectedRows) !== false;

          childWrapper.appendChild(
            buildParent(label, depth, events(key), parentIsActive),
            depth
          );

          const childContainerWrapper = document.createElement('dd');
          const hiddenDropdown = !parentIsActive;
          childContainerWrapper.setAttribute(
            'class',
            // Reusing style for now... so reason for ng-hide
            `check-boxes-dropdown-scroller ${hiddenDropdown ? 'ng-hide' : ''}`
          );

          let childContainer = document.createElement('fieldset');
          childContainer.setAttribute('class', 'check-boxes-dropdown-field');

          // Summary Check
          // if summary && depth !== 0
          // All Check
          const nestedParentSlug =
            `${parentSlug}${parentSlug.length ? '--' : ''}${key}`;
          const selectAllKey = `${nestedParentSlug}-all`;

          childContainer.appendChild(columnSelector({
            key: selectAllKey,
            parentSlug,
            label: '',
            isAll: true,
            events: events(
              selectAllKey,
              nestedParentSlug,
              (depth === 0) ? wrapups : {}
            ),
            isSelected: deepFind(
              [...parentKeys, key, 'all'], // Check for select all
              selectedRows
            ) !== false ||
              deepFind(
                [...parentKeys, 'all'], // Check for select all in parent
                selectedRows
              ) !== false,
          }));

          // Iterate over this map's children
          childContainer = iterateOverChildNodes({
            container: childContainer,
            map: children,
            parentSlug: nestedParentSlug,
            depth: depth + 1,
            events,
            selectedRows,
            sortMethod,
            wrapups,
            isMedicare,
          });

          childContainerWrapper.appendChild(childContainer);
          childWrapper.appendChild(childContainerWrapper);
          wrapper.appendChild(childWrapper);
          acc.appendChild(wrapper);
        } else {
          const isSelected =
            deepFind(
              [...parentKeys, key],
              selectedRows
            ) !== false ||
            // Ignore wrapups
            (
              parentSlug.indexOf('wrapup') === -1 &&
              deepFind(
                [...parentKeys, 'all'], // Check for select all
                selectedRows
              ) !== false
            ) ||
            // Go up a level to see if we need to select this
            deepFind(
              [...parentKeys.slice(0, 1), 'all'],
              selectedRows
            ) !== false;

          acc.appendChild(
            mapEventsToColumnSelector(
              events,
              key,
              label,
              parentSlug,
              isSelected
            )
          );
        }
        return acc;
      },
      container
    );
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/refineColumns/children/iterateOverChildNodes.js
 **/